'use strict';
// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('CidadesService', function($http) {
  return {
    list: function(filters) {
      return $http.get(`${SERVER}${API_VERSION}cidades`, {
        params: filters
      });
    },

    ufs: function() {
      return $http.get(`${SERVER}${API_VERSION}cidades/ufs`);
    }
  };
});
